export default __webpack_public_path__ + "static/media/BeramoniumIcon.f1cf60b8.jpeg";